import React from 'react';
import { FaFacebookF, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";
import { SiZalo } from "react-icons/si";

import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    // <>
    // </>
     <footer className="bg-[#f8f7f5] text-gray-800 text-sm">
      <div className="max-w-7xl mx-auto py-10 px-4 grid grid-cols-1 md:grid-cols-3 gap-8 border-t text-center md:text-left">
        <div>
          <h3 className="font-bold mb-2 uppercase">Thông tin</h3>
          <div className="flex justify-center md:justify-start p-3">
            <a href="/" aria-label="PT2000">
              <img
                className="h-8 w-auto"
                src="/logopt2000.png"
                alt="Logo PT2000"
              />
            </a>
          </div>
          <p className="pt-3" >Hộ Kinh Doanh PT2000</p>
          <p >ĐC: 153AB Nam Kỳ Khởi Nghĩa, P.Xuân Hòa, Tp.HCM</p>
          <p>ĐT: 028 39.303.753</p>
          <p>MST: 0305047147</p>
          <p>Giấy chứng nhận đăng ký hộ kinh doanh: 41C8008772</p>
          <p>Đăng ký lần đầu: Ngày 03 tháng 07 năm 2007</p>
          <p>Đăng ký thay đổi lần thứ: 1, Ngày 08 tháng 08 năm 2023</p>
          <p>Nơi cấp: Phòng tài chính kế hoạch quận 3, Tp.HCM</p>
        </div>

        <div>
          <h3 className="font-bold mb-2 uppercase">Liên hệ</h3>
          <ul className="space-y-1">
            <li><a href="/gioi-thieu">Giới thiệu</a></li>
            {/* <li><a href="/tro-giup">Trợ giúp</a></li> */}
            <li><a href="/lien-he">Liên Hệ</a></li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-2 uppercase">Hỗ trợ khách hàng</h3>
          <ul className="space-y-1">
            <li><a href="/huong-dan-mua-hang" >Hướng dẫn mua hàng</a></li>
            <li><a href="/huong-dan-su-dung" >Hướng dẫn sử dụng</a></li>
            <li><a href="/chinh-sach-giao-hang">Chính sách giao hàng</a></li>
            <li><a href="/chinh-sach-doi-tra">Chính sách đổi trả hoàn tiền</a></li>
            <li><a href="/chinh-sach-bao-mat">Chính sách bảo mật thông tin</a></li>
          </ul>
        </div>
        
      </div>

      <div className="border-t text-center text-xs py-4 px-4">
        <div className="flex justify-center space-x-4 mb-2 text-lg">
          <a href="https://www.facebook.com/pt2000.com.vn" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/pt2000_official" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.youtube.com/@PTFASHION-bw5ki" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <FaYoutube />
          </a>
          <a href="https://www.tiktok.com/@pt2000_official" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
            <FaTiktok />
          </a>
          <a href="https://zalo.me/1400537375598399273" target="_blank" rel="noopener noreferrer" aria-label="Zalo">
            <SiZalo />
          </a>
        </div>
        <p>© PT2000 2025. All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
